<script>
  export let brk;
  export let lun;
  export let id;
  export let days;
  export let carb;
  export let availableMeals;

  const products = fetch("http://localhost:5001/shop-products").then(res =>
    res.json()
  );

  let newOrder = {
    OrderInfo: {
      OrderID: id,
      NumBrk: brk,
      NumLD: lun,
      NumDays: days,
      NoCarbs: carb
    }
  };

  let selectedProducts = [];
  let qtyTracker = {};

  $: totalSelected = selectedProducts.length
    ? Object.values(qtyTracker).reduce((a, b) => a + b)
    : 0;

  $: selectedIDs = selectedProducts.length
    ? selectedProducts.map(p => p.Prod_ID)
    : [];

  $: availableMeals = (lun + brk) * days - totalSelected;

  const addToSelect = (id, name, qty) => {
    let obj = {};

    obj.Prod_ID = id;
    obj.Prod_Name = name;
    obj.Prod_Qty = qty;

    qtyTracker[name] = parseInt(qty);

    selectedProducts = [...selectedProducts, obj];

    if (selectedIDs.includes(id)) {
      let filtered = selectedProducts.filter(p => p.Prod_ID !== id);
      selectedProducts = [...filtered, obj];
    }

    if (qty === "0") {
      let filtered = selectedProducts.filter(p => p.Prod_ID !== id);
      selectedProducts = filtered;
    }

    document.getElementById(id).style.display = "none";
  };

  const removeProductFromSelect = (id, name) => {
    let filtered = selectedProducts.filter(p => p.Prod_ID !== id);
    selectedProducts = filtered;
    let selected = document.getElementById(id);
    selected.value = "";
    delete qtyTracker[name];
    document.getElementById(id).style.display = "block";
  };

  const addProductsToOrder = orderObj => {
    orderObj.Products = selectedProducts;
  };

  const resetOrder = ids => {
    selectedProducts = [];

    ids.forEach(id => {
      let selected = document.getElementById(id);
      selected.style.display = "block";
      selected.value = "";
    });
    qtyTracker = {};
  };

  const submitOrder = order => {
    const raw = JSON.stringify(order);
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: raw,
      redirect: "follow"
    };

    fetch("http://localhost:5001/send", config)
      .then(data => {
        console.log(data);
      })
      .catch(err => console.log(err));
  };
</script>

<hr />
<h2>Number of Selected Meals {totalSelected}</h2>
{#if selectedProducts.length}
  <h3>You Have Selected:</h3>
  <table>
    <thead>
      <tr>
        <td>Meal Name</td>
        <td>Qty</td>
        <td>Remove</td>
      </tr>
    </thead>
    {#each selectedProducts as product, i (product.Prod_ID)}
      <tr>
        <td>{product.Prod_Name}</td>
        <td>{product.Prod_Qty}</td>
        <td>
          <button
            on:click={() => removeProductFromSelect(product.Prod_ID, product.Prod_Name)}>
            x
          </button>
        </td>
      </tr>
    {/each}
  </table>
  <div>
    <br />
    <button on:click={() => resetOrder(selectedIDs)}>Reset Order</button>
    <button
      on:click={() => {
        addProductsToOrder(newOrder);
        console.log(newOrder);
      }}>
      Submit Order
    </button>
  </div>
{/if}
<br />
{#await products}
  <!-- products is pending -->
  <p>loading products</p>
{:then allProducts}
  {#if brk > 0}
    <h2>Breakfast Meals</h2>
    <table>
      <thead>
        <tr>
          <td>Meal Name</td>
          <td>Qty</td>
        </tr>
      </thead>
      {#each allProducts.products as product, i (product.id)}
        {#if product.tags.includes('Breakfast')}
          <tr id={product.id}>
            <td>{product.title}</td>
            <td>
              <select
                name={product.id}
                on:change={e => {
                  addToSelect(product.id, product.title, e.target.value);
                }}>
                <option value="0" />
                {#each Array(availableMeals) as _, index}
                  <option value={index + 1} class="option">{index + 1}</option>
                {/each}
              </select>
            </td>
          </tr>
        {/if}
      {/each}
    </table>
  {/if}
  {#if lun > 0}
    <h2>Lunch/Dinner Meals</h2>
    <table>
      <thead>
        <tr>
          <td>Meal Name</td>
          <td>Qty</td>
        </tr>
      </thead>
      {#each allProducts.products as product, i (product.id)}
        {#if product.tags.includes('Lunch/Dinner')}
          <tr id={product.id}>
            <td>{product.title}</td>
            <td>
              <select
                name={product.id}
                on:change={e => {
                  addToSelect(product.id, product.title, e.target.value);
                }}>
                <option value="0" />
                {#each Array(availableMeals) as _, index}
                  <option value={index + 1} class="option">{index + 1}</option>
                {/each}
              </select>
            </td>
          </tr>
        {/if}
      {/each}
    </table>
  {/if}
{:catch error}
  <!-- products was rejected -->
{/await}
